'use client';

import { useAtom } from 'jotai';

import Toast from '@/components/basics/Toast';
import toastAtom from '@/stores/atoms/toastAtom';

export default function ToastWrapper({ children }: { children: React.ReactNode }) {
  const [toast] = useAtom(toastAtom);

  return (
    <>
      <Toast text={toast.text} isOpen={toast.isOpen} type={toast.type} />
      {children}
    </>
  );
}
